// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__SGSoF","resendInfoText":"OnGoingPaymentBox_resendInfoText__1zaIT"};